import React  from 'react'
import RefExampleSource from './RefExampleSource';


export default class RefExampleChild extends React.Component 
{
    static defaultProps={

    };

    constructor(props) 
    {
        super(props);
        this.state = {
        };
    }

    componentDidMount() 
    {
        
    }

    render()
    {
        
        return (
            <div className='border bg-primary p-2 m-2'>
                <div>This is the RefExampleChild component.</div>
                <RefExampleSource callRef={this.props.callRef}/>
            </div>

        );
    }
}

